module.exports = __webpack_public_path__ + "121d613863a872004b04d5a1d782b3e4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Light.ttf
// module id = 1810
// module chunks = 1